import GetProgramsDTO from '../dtos/get-programs.dto';
import apiClient from './axiosClient';

const getNumberOfTrainingResultsRequest = async (
  params: GetProgramsDTO = {},
): Promise<number> => {
  return apiClient
    .get(`programs/number-of-results`, { params })
    .then((res) => res.data);
};

export default getNumberOfTrainingResultsRequest;
